import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";


import { NewPasswordComponent } from "./newPassword-form.component";
import { FormsModule } from "@angular/forms";
import { DirectivesModule } from "app/directives/directives.module";

@NgModule({
  declarations: [
    NewPasswordComponent
  ],
  exports: [
    NewPasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule
  ]
})
export class NewPasswordModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/account/asset/newPassword/newPassword-form.module.ts